import { Controller } from "@hotwired/stimulus"

// Manages the collapsible admin sidebar event list and persists open state per session.
export default class extends Controller {
  static values = {
    storageKey: { type: String, default: "adminSidebarEvents" }
  }

  connect() {
    this.openIds = new Set(this.readStorage())
    this.initialiseItems()
  }

  toggle(event) {
    event.preventDefault()
    const item = event.currentTarget.closest("[data-event-id]")
    if (!item) return

    const panel = item.querySelector("[data-admin-sidebar-panel]")
    const chevron = item.querySelector("[data-admin-sidebar-chevron]")
    const toggleButton = item.querySelector("[data-admin-sidebar-toggle]") || event.currentTarget

    if (!panel || !toggleButton) return

    const nextState = panel.classList.contains("hidden")
    this.setOpenState(item, panel, chevron, toggleButton, nextState)
    this.persistState(item.dataset.eventId, nextState)
  }

  initialiseItems() {
    this.element.querySelectorAll("[data-event-id]").forEach((item) => {
      const panel = item.querySelector("[data-admin-sidebar-panel]")
      const chevron = item.querySelector("[data-admin-sidebar-chevron]")
      const toggleButton = item.querySelector("[data-admin-sidebar-toggle]")

      if (!panel || !toggleButton) return

      const isActive = item.dataset.active === "true"
      const shouldOpen = isActive || this.openIds.has(item.dataset.eventId)
      this.setOpenState(item, panel, chevron, toggleButton, shouldOpen)
    })
  }

  setOpenState(item, panel, chevron, toggleButton, open) {
    if (open) {
      panel.classList.remove("hidden")
      item.classList.add("bg-slate-50", "border", "border-slate-200")
      toggleButton.setAttribute("aria-expanded", "true")
      if (chevron) chevron.classList.add("rotate-90")
    } else {
      panel.classList.add("hidden")
      item.classList.remove("bg-slate-50", "border", "border-slate-200")
      toggleButton.setAttribute("aria-expanded", "false")
      if (chevron) chevron.classList.remove("rotate-90")
    }
  }

  persistState(eventId, open) {
    if (!eventId) return

    if (open) {
      this.openIds.add(eventId)
    } else {
      this.openIds.delete(eventId)
    }

    this.writeStorage(Array.from(this.openIds))
  }

  readStorage() {
    try {
      const raw = window.sessionStorage.getItem(this.storageKeyValue)
      return raw ? JSON.parse(raw) : []
    } catch (error) {
      console.warn("Unable to read sidebar state", error)
      return []
    }
  }

  writeStorage(value) {
    try {
      window.sessionStorage.setItem(this.storageKeyValue, JSON.stringify(value))
    } catch (error) {
      console.warn("Unable to persist sidebar state", error)
    }
  }
}
